import { render, staticRenderFns } from "./ObjectCardWithTrigger.vue?vue&type=template&id=5103fc86&"
import script from "./ObjectCardWithTrigger.vue?vue&type=script&lang=js&"
export * from "./ObjectCardWithTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports